// eslint-disable-next-line
import { GetSensorStatus, GetAlertByCourse } from '@/api/api';
import { Mixin } from 'gw-js-lib';

export default {
  namespaced: true,
  state: { /* = data */
    alerts: [],
    sensorAlerts: [],
    alertStatusFilter: null,
    loading: {
      alerts: false,
    },
  },

  getters: { /* = Computed properties, perfects to filter data an execute some calculation */
    alertsFiltered(state) {
      if (state.alertStatusFilter) {
        return state.alerts.filter((alert) => alert.alert_type_id === state.alertStatusFilter);
      }
      return state.alerts;
    },
    sensorAlertsFiltered(state) {
      if (state.alertStatusFilter) {
        return state.sensorAlerts.filter((alert) => alert.alert_type_id === state.alertStatusFilter);
      }
      return state.sensorAlerts;
    },
  },


  actions: { /* = Methods */

    async loadAlerts({ commit, state, getters }, hideLoading) {
      if (Mixin.methods.G_isEmptyArr(getters.alertsFiltered) && !hideLoading) {
        commit('setLoading', { ...state.loading, alerts: true });
      }

      await GetAlertByCourse().then((response) => {
        commit('setAlerts', response.alerts);
        commit('setLoading', { ...state.loading, alerts: false });
      }).catch(() => {
        commit('setLoading', { ...state.loading, alerts: false });
      });
    },
  },

  mutations: { /* Mutations are responsible to change the state */
    setAlerts(state, alerts) {
      state.alerts = alerts;
    },
    setSensorAlerts(state, sensorAlerts) {
      state.sensorAlerts = sensorAlerts;
    },
    setAlertStatusFilter(state, alertStatusFilter) {
      state.alertStatusFilter = alertStatusFilter;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    resetAlertStatusFilter(state){
      state.alertStatusFilter = null;
    }
  },

};
